/* src/app/modules/contact/center/center.component.css */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.ctr-page {
  min-width: 0;
  max-height: none;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
}
.ctr-header-text {
  min-width: 0;
  padding-right: 32px;
}
.ctr-header-text .cf-dlg-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ctr-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.ctr-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 36px 16px;
  text-align: center;
}
.ctr-state > mat-icon {
  font-size: 44px;
  width: 44px;
  height: 44px;
  color: #d1d5db;
  margin-bottom: 6px;
}
.ctr-state--error > mat-icon {
  color: #dc2626;
}
.ctr-state__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #374151;
}
.ctr-state__sub {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.ctr-state .cf-btn {
  margin-top: 10px;
}
.ctr-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ctr-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  min-width: 0;
}
.ctr-row__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9px;
  background: #f4f6f8;
  flex-shrink: 0;
}
.ctr-row__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #6b7280;
}
.ctr-row__info {
  flex: 1;
  min-width: 0;
}
.ctr-row__name {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1a1d23;
  overflow-wrap: anywhere;
}
.ctr-code {
  padding: 1px 7px;
  border-radius: 6px;
  background: #f4f6f8;
  color: #4b5563;
  font-size: 11px;
  font-weight: 600;
}
.ctr-row__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 12px;
  margin-top: 3px;
  font-size: 12px;
  color: #6b7280;
  min-width: 0;
}
.ctr-row__meta span {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  min-width: 0;
  overflow-wrap: anywhere;
}
.ctr-row__meta mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #9ca3af;
  flex-shrink: 0;
}
.ctr-row__meta .ctr-badge {
  padding: 1px 8px;
  border-radius: 20px;
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
  font-size: 11px;
  font-weight: 600;
}
.ctr-row__meta .ctr-badge mat-icon {
  font-size: 12px;
  width: 12px;
  height: 12px;
  color: #2563eb;
}
.ctr-row__actions {
  display: flex;
  flex-shrink: 0;
}
.ctr-row__btn {
  width: 34px !important;
  height: 34px !important;
  padding: 5px !important;
  color: #6b7280 !important;
}
.ctr-row__btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.ctr-row__btn--danger:hover {
  color: #dc2626 !important;
}
.ctr-grid {
  display: grid;
  gap: 0 16px;
}
.ctr-grid--address {
  grid-template-columns: minmax(0, 3fr) minmax(0, 1fr);
}
.ctr-grid--face {
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
}
.ctr-hint {
  margin: -4px 0 12px;
  font-size: 12px;
  color: #6b7280;
}
.ctr-face {
  padding: 12px 14px 0;
  margin-bottom: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
}
.ctr-face__label {
  margin-bottom: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}
@media (max-width: 480px) {
  .ctr-grid--address,
  .ctr-grid--face {
    grid-template-columns: minmax(0, 1fr);
  }
  .ctr-row {
    gap: 8px;
    padding: 8px 4px 8px 10px;
  }
  .ctr-row__icon {
    display: none;
  }
  .ctr-row__btn {
    width: 32px !important;
    height: 32px !important;
    padding: 4px !important;
  }
}
/*# sourceMappingURL=center.component.css.map */
